import { AxiosStatic } from "axios";

import { AnsweredQuestionWithId, Questionnaire } from "@teamprevent/common/questionnaires/model";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { TaskType, AddTaskModel, parseTaskModel } from "../task/model";

export class BbvReportApi {
    private readonly apiUrl = "/api/bbvReport";

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async load(ohCaseId: string, taskId: string): Promise<Questionnaire> {
        const response = await this.axios.get(`${this.apiUrl}/${ohCaseId}/${taskId}`);
        return response.data as Questionnaire;
    }

    public async loadSuccessorTasks(): Promise<TaskType[]> {
        const response = await this.axios.get(`${this.apiUrl}/successorTasks`);
        return response.data as TaskType[];
    }

    public async submit(ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[], tasks: AddTaskModel[]): Promise<TaskModel[]> {
        const taskModels = tasks.map(task => ({
            taskType: task.type,
            taskCodeId: task.taskCodeId,
            dueDate: task.dueDate,
            notes: task.notes,
            assignedUsers: task.assignedUsers
        }));
        const response = await this.axios.post(`${this.apiUrl}/${ohCaseId}/${taskId}`, { report: { questions }, tasks: taskModels });
        return (response.data as TaskModel[]).map(parseTaskModel);
    }
}
